export default {
    name: 'richTextLabelValue',
    title: 'Legge',
    type: 'document',
    fields: [
        { 
            name: 'label',
            title: 'Nome',
            type: 'string',
          },
          { 
            name: 'value',
            title: 'Value',
            type: 'string',
          },
          { 
            name: 'fieldType',
            title: 'FieldType',
            type: 'string',
          },

        {
            name: 'richText',
            title: 'RichText',
            type: 'richTextObject'
        },

    ]
  }